export default "<template>\r\n  <div>\r\n    Example of an inline <code>&lt;code&gt;</code> element.\r\n  </div>\r\n</template>\r\n";